<template>
  <v-card style="background-color:#F7F7F7" elevation="7">
    <v-row clas="bm-0 mb-0 pb-0">
      <v-col cols="12" class="mx-6">
        <span class="headline font-weight-bold">
          {{ roleUser }}
        </span>
        <p class="font-weight mb-0">
          {{ currentUser.nombre }}  {{ currentUser.primer_apellido }}  {{ currentUser.segundo_apellido }}
        </p>
      </v-col>
      <v-col cols="12" clas="mt-0">
        <v-card class="mx-4" color="#CED7DB">
          <v-toolbar color="#006064" dark dense>
            <v-toolbar-title>Registrar Amparos</v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-spacer></v-spacer>
      <v-col cols="7" md="6" class="pt-0" v-if="sala_id">
        <v-text-field
          placeholder="Ingresar Toca"
          v-model="buscar"
          hint="Solo números"
          :loading="loading"
          clearable
          clear-icon="mdi-close-circle"
          @click:clear="clearSearch"
          v-on:keyup.enter="searchToca"
        >
          <v-btn slot="prepend" outlined fab x-small color="green" @click='searchToca'>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="4" md="6" class="pt-0">
        <v-autocomplete
          :items = "listSalas"
          label="Seleccione una Sala"
          item-text="nombre"
          item-value="id"
          persistent-hint
          v-model="sala_id"
          required
          :rules="[v => !!v || 'Campo requerido']"
          key="id"
          :loading="loading"
          v-if="roleUser == 'superadmin' "
          @change="clearSearch()"
        />
      </v-col>
    </v-row>
    <v-row class="mx-5">
        <v-col cols="10" md="6" class="pt-0" v-if="sala_id">
          <v-alert
            v-model='no_result'
            dismissible
            border="left"
            colored-border
            type="error"
            elevation="2"
          >
            No hay registro del toca
          </v-alert>
        </v-col>
    </v-row>
      <v-divider inset></v-divider>
      <br>
      <!-- <v-card v-if="getToca"
        style="background-color: #F7F7F7"
        elevation="2"
        shaped
      > -->
      <v-row  class="bm-1 mb-1 pb-1 mx-6">
        <v-col
          cols="12"
          sm="6"
        >
          <v-card style="background-color:#F7F7F7" flat>
            <v-system-bar
              height="30"
              class="text-h6 indigo darken-3 white--text"
            > Datos del Toca</v-system-bar>

            <v-list style="background-color:#F7F7F7">
              <v-list-item dense>
                <v-list-item-action>
                  <v-icon>mdi-folder-open</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  Toca: {{ num_toca}}
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-folder</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  Expediente: {{expediente}}
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-office-building</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Juzgado: {{juzgado}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-map-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Municipio: {{municipio}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-repeat</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Reconvención: {{reconvencion}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-card v-if="getToca != null" flat>
            <v-system-bar
              height="30"
              class="text-h6 pink darken-3 white--text"
            > Partes</v-system-bar>

            <v-list style="background-color:#F7F7F7" v-if="getToca">
              <v-list-item>
                <v-list-item-action>
                  <v-icon>mdi-human-handsdown</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  Actor: {{actor}}
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item class="my-0">
                <v-list-item-action>
                  <v-icon>mdi-human-male</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  Demandado: {{demandado}}
                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-card>
        </v-col>
      </v-row>

          <v-card v-if="getToca" style="background-color:#F7F7F7">
          <v-system-bar
            height="30"
            class="text-h6 blue darken-3 white--text bm-1 mb-1 pb-1 mx-12"
          > Apelaciones</v-system-bar>
            <v-data-table
              fixed-header
              height="300px"
              class="bm-1 mb-1 pb-1 mx-12 elevation-1"
              :headers="headers"
              :items="apelaciones"
              :single-select="singleSelect"
              sort-by="id"
              hide-default-footer
              disable-pagination
            >
            <template v-slot:item.action="{ item }">
              <div v-if="item.ultima" >
                  <component :is="currentComponent" :sala_id="sala_id" :apelacion_data="item"></component>
              </div>
            </template>

            <template v-slot:item.status="{ item }">
              <span v-if="item.status == 20">
                PARA TURNAR A PONENCIA
              </span>
              <span v-if="item.status == 30">
                PARA TURNAR RELATOR
              </span>
              <span v-if="item.status == 40">
                ASIGNADAS A RELATOR
              </span>
              <span v-if="item.status == 41">
                PARA CUENTA
              </span>
              <span v-if="item.status == 42">
                PARA SESIONAR
              </span>
              <span v-if="item.status == 43">
                EN CUENTA COLEGIADA
              </span>
              <span v-if="item.status == 44">
                PENDIENTES DE FIRMA
              </span>
              <span v-if="item.status == 45">
                CONCLUIDAS
              </span>
              <span v-if="item.status == 50">
                CANCELADAS
              </span>
              <span v-if="item.status == 60">
                SIN MATERIA
              </span>
              <span v-if="item.status == 1">
                PARA AMPARO
              </span>
            </template>

          </v-data-table>
          <br>
          </v-card>
        <v-card>
      </v-card>
    </v-card>

  <!-- </v-card> -->
</template>

<script>
  import NewAmparo from "../../components/NewAmparo";
  import ShowToca from "../../components/ShowToca";
  import Asignar from "../../components/Asignar";

  import { mapMutations } from "vuex";
  import { mapGetters } from "vuex";

  export default {
    components: {
       NewAmparo, ShowToca, Asignar
    },
    props: {
      source: String
    },
    data() {
      return {
        selec:'',
        singleSelect: true,
        current:1,
        itemsPerPage: 20,
        total:0,
        status: { "text": "INTEGRACION", "value": 10, "align": "", "sortable": true, "width": "" },
        loading: false,
        buscar: '',
        sala_id: '',
        apelacion_data: '',
        num_toca: '',
        expediente: '',
        juzgado: '',
        municipio: '',
        actor:'',
        demandado: '',
        reconvencion: '',
        item:'',
        dialog: false,
        anio:'',
        numero:'',
        no_result:'',
        currentComponent:'NewAmparo',
        getToca: [],
        apelaciones:[],
        menu_excusa: [
          { name: "Registrar", icon: "mdi-plus" },
          { name: "Mostrar Todo", icon: "mdi-account-multiple-plus" }
        ],
        headers: [
          { text: "Tipo de Apelación", value: "tipo_apelacion_nombre" },
          { text: "Fecha de Sentencia", value: "fecha_recepcion" },
          { text: "Status", value: "status" },
          { text: "", value: "action", align: "center", sortable: false },
        ],
        headers_apelaciones: [],
        items_status: [
          { text: "INTEGRACION", value: 10, align: "", sortable: true, width: '' },
          { text: "PARA TURNAR", value: 20, align: "", sortable: true, width: '' },
          { text: "TURNADA", value: 30, align: "", sortable: true, width: '' },
          { text: "REGISTRADA PARA AMPARO", value: 1, align: "", sortable: true, width: '' },
        ]
      };
    },
    computed: {
      ...mapGetters(["listSalas", "roleUser", "currentUser", "getAllPonencias","tocasList"])
    },
    created() {
      // this.getApelaciones();
      this.$store.dispatch("GET_SALAS", { url: "salas" });
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      if (this.roleUser == 'superadmin') {
        this.loading = false
        return false;
      } else {
        let user = JSON.parse(localStorage.getItem('user'));
        this.sala_id = user.ponencia.sala_id
      }
      //this.getApelaciones();
    },
    methods: {
      getApelaciones(){
        this.loading = true
        this.getToca = []
        this.apelaciones = []

          this.$store.dispatch("GET_TOCAS", {
            url: "/tocas",
            params: {
              sala_id:  this.sala_id,
              anio:  this.anio || undefined,
              numero:  this.numero || undefined
            }
          }).then(response => {
            this.loading = false
            this.no_result = false;

            this.getToca = response.data.data.toca;
            this.num_toca = this.getToca.numero+ '/' + this.getToca.anio
            this.expediente = this.getToca.expediente;
            this.apelaciones = this.getToca.apelaciones_data;
            this.juzgado = this.getToca.juzgado_data.nombre;
            this.municipio = this.getToca.juzgado_data.municipio_data.nombre;
            this.actor = this.getToca.apelaciones_data[0].actor;
            this.demandado = this.getToca.apelaciones_data[0].demandado;
            this.reconvencion = this.getToca.apelaciones_data[0].accion_reconvencion;

          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.no_result = true;
          });
      },
      searchToca(){
        if (!this.buscar) return false;
        if (this.buscar.length >= 5 ) {
          this.status = {}
          if ( this.buscar.includes("/") ) var tocacompleto = this.buscar.replace('/','');
          else var tocacompleto = this.buscar;
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          this.getApelaciones()
        }
      },
      clearSearch () {
        this.num_toca = ''
        this.expediente = ''
        this.anio = ''
        this.juzgado= ''
        this.municipio= ''
        this.actor= ''
        this.demandado= ''
        this.no_result = false
      }
    }
  };
</script>
